import { render, staticRenderFns } from "./Triangle.vue?vue&type=template&id=5d8be212&"
import script from "./Triangle.vue?vue&type=script&lang=js&"
export * from "./Triangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "b3fcfafc"
  
)

export default component.exports